import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
export function PrescriptionRequired() {
  return <div className="flex h-full flex-col rounded-xl border border-amber-200 bg-amber-50 p-3 shadow-sm" data-id="element-4935" data-mp="2npk988e06ba6">
      <div className="mb-3 flex items-start gap-2" data-id="element-4936" data-mp="2sox2pbzdqglq">
        <div className="shrink-0 rounded-full bg-white p-1.5" data-id="element-4937" data-mp="2sr9h5f5xi8u1">
          <StethoscopeIcon className="h-4 w-4 text-amber-700" data-id="element-4938" data-mp="2wrjn4rtq0z8w" />
        </div>
        <div data-id="element-4939" data-mp="31qmw2nctnpm5">
          <h3 className="text-sm font-bold leading-snug text-gray-900" data-id="element-4940" data-mp="31otjkrfj2b68">Prescription required</h3>
          <p className="mt-1 text-xs leading-snug text-gray-700" data-id="element-4941" data-mp="36nwj5wcqnp6t">Request a prescription online.</p>
        </div>
      </div>
      <button className="mt-auto flex w-full items-center justify-center gap-1.5 rounded-lg bg-brand px-2 py-2 text-xs font-bold text-white transition-colors duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-4942" data-mp="3bgg6hl189yot">
        <StethoscopeIcon className="h-4 w-4" data-id="element-4943" data-mp="3pfyzf6lgx3gj" />
        Consult doctor
      </button>
    </div>;
}